var _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoAnimatedHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ex0DTZEXWup1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 800 369",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ex0DTZEXWup2",
    transform: "translate(.419208 0)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.037307 0.999304 0.999304-.037307 764.9 107.381)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6.331,-74.803h81.431L48.489,-5.484l-28.146-.151-26.674-69.168Z",
    clipRule: "evenodd",
    fill: "#f7e07d",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.945406-.325895-.325895 0.945406 762.498 141.887)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-23.193,-12.4h30.081l-10.3,26.194-22.126-20.13c-2.357-2.144-.841-6.065,2.345-6.064",
    clipRule: "evenodd",
    fill: "#685d4a",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(702.099 149.503)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,21.721c-.26-7.018-6.374-12.523-9.894-13.235c3.38-.987,9.145-6.925,8.885-13.928-.246-6.638-5.761-11.979-9.335-13.139c3.42-1.443,8.582-7.161,8.336-13.778-.266-7.176-6.652-12.771-10.125-13.273l-611.62,31.554l3.094,81.431L-9.113,35.705c3.338-.77,9.379-6.819,9.113-13.984",
    clipRule: "evenodd",
    fill: "#fbc726",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.2819 217.847)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.001,
    height: 0.001,
    rx: 0,
    ry: 0,
    clipRule: "evenodd",
    fill: "#aba5ab",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.998672 0.051515 0.051515 0.998672 65.4232 218.229)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.161,
    height: 81.717,
    rx: 0,
    ry: 0,
    transform: "translate(-19.042-82.208)",
    clipRule: "evenodd",
    fill: "#aba5ab",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.0741 219.993)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-83.754l-30.051,1.549c-11.536.595-20.406,10.429-19.811,21.965l2.054,39.834C-47.213,-8.87,-37.38,0,-25.843,-0.595l30.051-1.55L0,-83.754Z",
    clipRule: "evenodd",
    fill: "#e382b5",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(619.205 354.333)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-339.665h-464.893c-29.346,0-52.045,25.729-48.387,54.846l30.418,242.131C-479.798,-18.297,-459.058,0,-434.475,0h404.057c24.583,0,45.322-18.297,48.387-42.688l30.418-242.131c3.658-29.117-19.041-54.846-48.387-54.846",
    clipRule: "evenodd",
    fill: "#89b85d",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ex0DTZEXWup19",
    transform: "translate(348.271 143.177)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,12.109l-21.294-1.991.97-11.403c.163-1.915-1.255-3.597-3.171-3.76-1.93-.15-3.601,1.259-3.76,3.172L-28.22,9.471L-50.47,7.39l-.26-14.854c-.034-1.922-1.601-3.528-3.542-3.417-1.919.032-3.448,1.616-3.417,3.538l.247,14.081L-74.96,5.101l.914-8.914c.194-1.911-1.196-3.62-3.105-3.816-1.937-.195-3.618,1.195-3.819,3.106l-.921,8.976-16.236-1.518l2.658-12.186c.408-1.878-.782-3.732-2.66-4.14-1.857-.415-3.729.78-4.14,2.657l-2.84,13.016-18.402-1.721l1.558-12.719c.235-1.907-1.121-3.644-3.03-3.877-1.875-.221-3.642,1.124-3.874,3.03l-1.582,12.919-21.213-1.984l2.492-14.451c.329-1.894-.944-3.694-2.836-4.019-1.892-.32-3.694.942-4.019,2.836L-158.6,-2.719l-17.936-1.677c-1.927-.184-3.608,1.229-3.787,3.14-.18,1.913,1.224,3.608,3.137,3.788l17.4,1.627-2.704,15.677c-.329,1.894.944,3.694,2.836,4.019.201.035.398.052.595.052c1.664,0,3.134-1.195,3.424-2.888l2.797-16.211l21.553,2.015-1.456,11.885c-.235,1.908,1.121,3.644,3.03,3.878.142.017.284.026.425.026c1.733,0,3.234-1.294,3.449-3.056l1.48-12.085l17.755,1.66-3.432,15.732c-.408,1.878.782,3.732,2.66,4.14.249.056.498.082.743.082c1.602,0,3.041-1.111,3.397-2.738l3.613-16.563l17.019,1.591-.959,9.345c-.193,1.911,1.197,3.619,3.106,3.815.121.012.242.019.36.019c1.764,0,3.272-1.334,3.459-3.125l.965-9.406l18.352,1.716.277,15.811c.034,1.9,1.584,3.419,3.479,3.419.021,0,.042,0,.063-.002c1.919-.033,3.448-1.617,3.417-3.538l-.264-15.039l21.537,2.014-1.032,12.143c-.163,1.914,1.255,3.597,3.171,3.76.101.008.201.013.298.013c1.788,0,3.31-1.371,3.462-3.185l1.027-12.083L-0.65,19.037c.11.01.221.015.328.015c1.775,0,3.293-1.352,3.459-3.156.18-1.912-1.224-3.607-3.137-3.787",
    clipRule: "evenodd",
    fill: "#77a546",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(619.205 99.4463)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-84.779h-464.893c-29.346,0-52.045,25.729-48.388,54.846l3.749,29.838c44.332-1.033,45.187-32.267,91.004-32.267c46.571,0,46.571,32.362,93.14,32.362c46.583,0,46.583-32.362,93.165-32.362c46.599,0,46.599,32.362,93.197,32.362c46.583,0,46.583-32.362,93.167-32.362c45.648,0,46.71,30.952,90.501,32.241l3.745-29.812C52.045,-59.05,29.346,-84.779,0,-84.779",
    clipRule: "evenodd",
    fill: "#685d4a",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "ex0DTZEXWup23",
    transform: "matrix(-1 0 0-1 780.453278 469.237213)",
    mask: "url(#ex0DTZEXWup28)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 457.221529,
    height: 189.660727,
    rx: 0,
    ry: 0,
    transform: "matrix(1 0 0 0.888448 161.615856 149.366754)",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "ex0DTZEXWup25",
    transform: "translate(-.6319 21.796269)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 29.868007,
    ry: 29.868007,
    transform: "translate(505.110534 194.92206)",
    fill: "#685d4a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 29.868007,
    ry: 29.868007,
    transform: "translate(268.08106 209.192533)",
    fill: "#685d4a",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ex0DTZEXWup28",
    "mask-type": "luminance"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ex0DTZEXWup29",
    transform: "translate(-.000382 0)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(357.118 298.912)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-96.027c15.618017,15.586282-4.847668,93.461-84.168,93.461s-108.475562-69.076313-93.516025-84.005457s38.214055-2.127055,88.138662-4.646662s73.927346-20.395163,89.545363-4.808881Z",
    transform: "matrix(.948118 0 0 1.002036 236.395334-11.901533)",
    clipRule: "evenodd",
    fill: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-96.027c15.618017,15.586282-4.847668,93.461-84.168,93.461s-108.475562-69.076313-93.516025-84.005457s38.214055-2.127055,88.138662-4.646662s73.927346-20.395163,89.545363-4.808881Z",
    transform: "matrix(.948118 0 0 1.002036 0.395334 0.098467)",
    clipRule: "evenodd",
    fill: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "ex0DTZEXWup35",
    transform: "matrix(1 0 0 1.006647 0-6.458378)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.520467,215.049708q31.812866-22.456141,71.111111-22.456141c39.298245,0,63.62573,23.391814,63.62573,23.391814",
    transform: "matrix(1.116258 0 0 0.836806-5.733169 56.024402)",
    fill: "none",
    stroke: "#77a546",
    strokeWidth: 20,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.520467,215.049708q31.812866-22.456141,71.111111-22.456141c39.298245,0,63.62573,23.391814,63.62573,23.391814",
    transform: "matrix(1.116258 0 0 0.836806 228.301097 51.248193)",
    fill: "none",
    stroke: "#77a546",
    strokeWidth: 20,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAnimatedHappy);
export default __webpack_public_path__ + "static/media/logo-animated-happy.29b3ece582ef37c8138410ca5edd53e4.svg";
export { ForwardRef as ReactComponent };